<template>
    <div class="mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <multiselect
            v-model="newsCategorySelected"
            :options="newsCategories"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            :placeholder="placeholder"
            label="name"
            track-by="id"
            :preselect-first="true"
            :hide-selected="false"
            select-label=""
            selected-label="Sélectionné"
            deselect-label=""
        >
            <!-- Croix pour tout désélectionner -->
            <template #clear>
                <span class="multiselect__clear" role="button" v-if="newsCategorySelected && (newsCategorySelected.id ?? newsCategorySelected.code ?? newsCategorySelected.name ?? newsCategorySelected.label) != null" title="Effacer" aria-label="Effacer" @mousedown.prevent.stop="newsCategorySelected = null"></span>
            </template>
        </multiselect>
        <span class="invalid-feedback text-danger" v-html="errorMessage()"></span>
        <span class="form-text text-muted" v-if="informationContent !== null">
            {{ informationContent }}
        </span>
    </div>
</template>

<script>
export default {
    name: "FormSelectCategory",
    props: {
        name : {
            type: String,
            required: true
        },
        label : {
            type: String,
            required: true
        },
        labelHidden : {
            type: Boolean,
            required: false,
            default: false
        },
        required : {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        informationContent : {
            type: String,
            required: false,
            default: null
        },
        reference : {
            type: String,
            required: false,
            default: 'multiple-select'
        },
        categoryPreSelected: {
            type: Object,
            required: false,
            default: null
        },
        errors: {
            required: true
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        },
        categoryType: {
            type: String,
            required: true
        },

    },
    data() {
        return {
            newsCategorySelected : [],
            newsCategories: [],
            loading: false,
        }
    },
    mounted() {
        this.getCenters();
    },
    methods: {
        getCenters() {
            axios.get('/api/categories?category_type='+this.categoryType+'&sortingField=name&sortingOrder=asc&all')
                .then(response => {
                    response.data.data.forEach(
                        newsCategory => this.newsCategories.push({
                            id: newsCategory.data.id,
                            name: newsCategory.data.name
                        })
                    );
                })
                .catch(error => {
                    console.log(error);
                });
        },
        clearAll () {
            this.newsCategorySelected = []
        },
        clearErrors: function() {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorClassObject: function() {
            return {
                "is-invalid": this.hasError
            }
        },
        errorMessage: function() {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            );
        }
    },
    watch: {
        newsCategorySelected: function(){
            if( this.newsCategorySelected === null) {
                return this.$emit("update:field", null);
            } else {
                this.clearErrors(this.name);
                return this.$emit("update:field", this.newsCategorySelected);
            }
        },
        categoryPreSelected: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.categoryPreSelected !== null && Object.keys(this.categoryPreSelected).length !== 0 ) {
                    this.newsCategorySelected = {
                        id: this.categoryPreSelected.data.id,
                        name: this.categoryPreSelected.data.name
                    }
                    this.$emit("update:field", this.newsCategorySelected);
                }
            }
        }
    }
}
</script>

<style>

</style>
